// extracted by mini-css-extract-plugin
export default {"editableImage":"VGz46","editableImageRemover":"_5G9yE","editImageButton":"xDMp+","image":"_1yHi0","dropZone":"tm2ZK","innerDropZone":"VR8XW"};